export const LB_VIEW_CREATE_MODAL = 'LB_VIEW_CREATE_MODAL';
